import { styled } from '@mui/material/styles';
import type { Placement } from 'api/types';

interface ModalContainerProps {
  isBuilderPreview: boolean;
  isFloatingBar: boolean;
  isMobile: boolean;
  isPositionLeft: boolean;
  isWidgetVisible: boolean;
  placement: Placement;
}

const getClosedModalBottom = (placement: Placement) => {
  switch (placement) {
    case 'top':
      return 'auto';
    default:
      return '0';
  }
};

const getClosedModalTop = (placement: Placement) => {
  switch (placement) {
    case 'top':
      return '0';
    default:
      return 'auto';
  }
};

const getClosedModalPadding = (
  isFloatingBar: boolean,
  placement: Placement,
) => {
  if (isFloatingBar) {
    switch (placement) {
      case 'top':
        return '20px 0 0 0';
      case 'middle':
        return '20px 0';
      default:
        return '0 0 20px 0';
    }
  }

  return '20px';
};

const generateModalStyles = ({
  isBuilderPreview,
  isFloatingBar,
  isMobile,
  isPositionLeft,
  isWidgetVisible,
  placement,
}: ModalContainerProps) => {
  const openModalContainer = `
    bottom: 0;
    height: 100%;
    width: 100%;
  `;

  const closedModalContainer = `
    align-content: center;
    top: ${getClosedModalTop(placement)};
    bottom: ${getClosedModalBottom(placement)};
    display: flex;
    height: 100%;
    justify-content: ${isPositionLeft ? 'flex-start' : 'flex-end'};
    padding: ${getClosedModalPadding(isFloatingBar, placement)};
    left: ${isPositionLeft && !isFloatingBar ? '8px' : 'auto'};
    right: ${!isPositionLeft && !isFloatingBar ? '8px' : 'auto'};
    width: 100%;
  `;

  const openResponsiveModalContainer = `
    bottom: 0;
    height: 100%;
    width: 100%;
  `;
  if (isWidgetVisible) {
    return isBuilderPreview || isMobile
      ? openResponsiveModalContainer
      : openModalContainer;
  }

  return closedModalContainer;
};

export const AppWrapper = styled('div')<{ focusBorderColor: string }>`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  &:focus {
    outline: none;
  }
  &:focus-visible {
    border: 2px solid ${props => props.focusBorderColor};
  }
`;
export const Container = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const getHelpButtonContainerAlignItems = ({
  isFloatingBar,
  isPositionLeft,
  placement,
}: {
  isFloatingBar: boolean;
  isPositionLeft: boolean;
  placement: Placement;
}) => {
  if (isFloatingBar) {
    switch (placement) {
      case 'top':
        return 'flex-start';
      case 'middle':
        return 'center';
      case 'bottom':
        return 'flex-end';
    }
  }

  return isPositionLeft ? 'flex-start' : 'flex-end';
};

export const HelpButtonContainer = styled('main')<{
  isFloatingBar: boolean;
  isPositionLeft: boolean;
  placement: Placement;
}>`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: ${props =>
    props.placement === 'top' ? 'flex-start' : 'flex-end'};
  align-items: ${props => getHelpButtonContainerAlignItems(props)};
  width: 100%;

  &.Help-Button-Container-enter {
    opacity: 0;
  }
  &.Help-Button-Container-exit {
    opacity: 0;
  }
  &.Help-Button-Container-enter-done {
    opacity: 1;
  }
`;

export const ModalContainer = styled('div')<ModalContainerProps>`
  border-radius: 10px;
  position: fixed;
  ${generateModalStyles}
`;
